import { gql } from '@grandvisionhq/graphql';

const NEWSLETTER_SUBSCRIBE = gql`
  mutation NewsletterSubscribe($input: NewsletterSubscribeInput!) {
    newsletterSubscribe(input: $input) {
      __typename
      status
      failures {
        ... on Failure {
          __typename
          message
        }
        ... on UnknownFailure {
          __typename
          message
        }
        ... on NetworkFailure {
          __typename
          message
        }
        ... on AuthorizationFailure {
          __typename
          message
        }
      }
    }
  }
`;

export { NEWSLETTER_SUBSCRIBE };
//# sourceMappingURL=newsletter-subscribe.js.map
